import React from 'react';
import { profile, softwares } from '../mock';

function SoftwareRow({ software }) {
  return (
    <li>
      <div className="flex items-baseline justify-between">
        <span className="text-cream font-medium">{software.name}</span>
        <span className="font-display text-orange-acc tracking-wider text-lg">
          {software.short}
        </span>
      </div>
      <div className="mt-2 h-[3px] bg-cream/15 overflow-hidden">
        <div className="h-full bg-orange-acc" style={{ width: `${software.level}%` }} />
      </div>
    </li>
  );
}

function SoftwarePanel() {
  return (
    <div className="bg-navy-2 border border-cream p-8 md:p-10">
      <p className="text-[10px] uppercase tracking-[0.3em] text-orange-acc">Toolkit</p>
      <h4 className="font-display text-3xl md:text-4xl text-cream mt-2">Softwares</h4>

      <ul className="mt-8 space-y-6">
        {softwares.map((s) => (
          <SoftwareRow key={s.name} software={s} />
        ))}
      </ul>

      <p className="mt-8 text-xs text-cream-soft/60 italic">
        + Pen, watercolour, paper engineering, and a stubborn sketchbook.
      </p>
    </div>
  );
}

function MetaCell({ label, value }) {
  return (
    <div>
      <p className="text-[10px] uppercase tracking-[0.3em] text-orange-acc">{label}</p>
      <p className="mt-2 text-cream">{value}</p>
    </div>
  );
}

function AboutCopy() {
  return (
    <div>
      <h3 className="font-display text-4xl md:text-6xl leading-tight text-cream">
        A renaissance student in pursuit of every medium that &nbsp;
        <span className="text-orange-acc italic font-serif-display">moves</span>&nbsp; her.
      </h3>
      <div className="mt-8 space-y-5 text-cream-soft/85 leading-relaxed max-w-[60ch]">
        <p>{profile.about}</p>
        <p>{profile.about2}</p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-6 max-w-lg">
        <MetaCell label="Program" value={profile.program} />
        <MetaCell label="Studying at" value={profile.university} />
        <MetaCell label="Based in" value={profile.location} />
        <MetaCell label="Year" value={profile.year} />
      </div>
    </div>
  );
}

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 border-t border-cream">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 mb-12">
          <span className="font-display text-orange-acc text-2xl">01</span>
          <span className="text-[11px] uppercase tracking-[0.32em] text-cream-soft/70">About</span>
          <div className="flex-1 h-px bg-cream/20" />
        </div>

        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-7">
            <AboutCopy />
          </div>
          <div className="md:col-span-5">
            <SoftwarePanel />
          </div>
        </div>
      </div>
    </section>
  );
}
